import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Input } from 'components';
import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';

class ModalEditDeviceInfos extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  handleSubmit(data, onSucess, onError) {

    API.put(`/devices/${this.props.device.id}/infos`, data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {

    let infos = this.props.device.infos;

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size="small">
          <Header icon="edit" content="Modification iPad" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions} sanitize>

              {/* Model */}
              <Form.Field>
                <label htmlFor="inputDeviceModel">Modèle</label>
                <Input id="inputDeviceModel" name="model" value={infos.model} />
              </Form.Field>

              {/* Serial number */}
              <Form.Field>
                <label htmlFor="inputDeviceSerialNumber">Numéro de série</label>
                <Input id="inputDeviceSerialNumber" name="serial_number" value={infos.serial_number} />
              </Form.Field>

              {/* Engraving */}
              <Form.Field>
                <label htmlFor="inputDeviceEngraving">Gravure</label>
                <Input id="inputDeviceEngraving" name="engraving" value={infos.engraving} />
              </Form.Field>

              {/* Lock pin */}
              <Form.Field>
                <label htmlFor="inputDeviceLockPin">Code de déverouillage</label>
                <Input id="inputDeviceLockPin" name="lock_pin" value={infos.lock_pin} />
              </Form.Field>

              {/* Admin password */}
              <Form.Field>
                <label htmlFor="inputDeviceLockPin">Mot de passe administrateur</label>
                <Input id="inputDeviceLockPin" name="admin_password" value={infos.admin_password} />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalEditDeviceInfos.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ModalEditDeviceInfos;
